import React, { useState, useEffect } from 'react'
import { castArray, isPlainObject } from 'lodash-es'
import { Cascader } from '@ow/comps'
import { useDitto } from '@ow/ditto-core'

// 可从remote 获取defaultValue orgs列表,需改为只能返回orgs
const Render = function ({ opts = {}, onChange, value, style = {} }) {
  const { onFetchRemoteData } = useDitto()
  const {
    remote: finalRemote = {},
    type,
    slug,
    selects: customSelects,
    fieldOpts = {},
  } = opts

  // 添加树形结构checkbox多选
  const { checkable = false } = fieldOpts

  const [orgs, setOrgs] = useState([])
  const [selectedObjectId, setSelectedObjectId] = useState(
    type === 'orgMultiple' ? [] : null
  )
  const handleSelectValues = (selectOptions) => {
    return type === 'orgMultiple'
      ? selectOptions.map((option) => option.id)
      : selectOptions.id
  }

  const commomApi = () => {
    const org = onFetchRemoteData('org')

    org.fetchTreeData().then((data = []) => {
      setOrgs(data)
    })
  }

  useEffect(() => {
    if (onFetchRemoteData) {
      // 如果配置了api,走extend请求定制接口
      if (finalRemote.api) {
        const extend = onFetchRemoteData('extend')

        extend[finalRemote.api](finalRemote.url, finalRemote.opts).then(
          (res) => {
            const { defaultValue, orgs: selects } = res || {}
            const finalDefaultValue =
              defaultValue || (res[slug] && res[slug].defaultValue)

            if (selects) {
              setOrgs(
                (selects || []).map((option) => {
                  return { ...option, label: option.title }
                })
              )
            } else if (res[slug] && res[slug].selects) {
              setOrgs(
                res[slug].selects.map((option) => {
                  return { ...option, label: option.title }
                })
              )
            } else {
              commomApi()
            }
            if (onChange && finalDefaultValue) {
              const _finalDefaultValue = isPlainObject(finalDefaultValue)
                ? finalDefaultValue.id
                : finalDefaultValue
              onChange(
                type === 'orgMultiple'
                  ? castArray(_finalDefaultValue)
                  : _finalDefaultValue
              )
            }
          }
        )
      } else if (customSelects) {
        setOrgs(
          (customSelects || []).map((option) => {
            return { ...option, label: option.title }
          })
        )
      } else {
        // 如果没配置走通用获取
        commomApi()
      }
    }
  }, [])

  useEffect(() => {
    if (!value) setSelectedObjectId(type === 'orgMultiple' ? [] : null)
    else setSelectedObjectId(value)
  }, [value])

  return (
    <div className="w-full" style={{ height: '32px' }}>
      <Cascader
        tree={orgs || []}
        inputStyle={{
          height: '34px',
          width: '100%',
          ...style,
        }}
        placeholder={opts.hint || `请选择${opts.title}`}
        inputClassName="right-input"
        fieldNames={{
          label: 'title',
          value: 'id',
          children: 'children',
        }}
        checkable={checkable}
        allowClear={false}
        multiple={type === 'orgMultiple'}
        onChange={(selectedKeys, selectedValues, a, b) => {
          setSelectedObjectId(handleSelectValues(b))
          onChange(selectedKeys)
        }}
        value={selectedObjectId || undefined}
        notFoundContent="暂无数据"
      />
    </div>
  )
}

export default Render
